import React, { useEffect, useMemo } from 'react'
import styles from './styles.module.css'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import Modal from './Modal'
import Table from '../../components/Table'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../components/Confirmation/Confirmation'
import { createTvProgramType, updateTvProgramType, deleteTvProgramType, getTvProgramType } from '../../actions/tvProgramType copy.js'
import { getSchoolWeeksList } from '../../actions/schoolWeeks'
import { createTvProgramSchedule, updateTvProgramSchedule } from '../../actions/tvProgramSchedule copy.js'
export default function TvProgramType() {

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { list } = useSelector(state => state.tv_program_type)

  const [selectedItem, setSelectedItem] = useState(null)
  const [addMode, setAddMode] = useState(false)
  const [confirmation, setConfirmation] = useState(false);
  const [sortAsc, setSortAsc] = useState(true)

  useEffect(() => {
    dispatch(getTvProgramType());
  }, [])

  const sortedList = useMemo(() => {
    if (!list) return []
    return [...list].sort((a, b) => sortAsc
      ? a.name?.localeCompare(b.name, 'ru')
      : b.name?.localeCompare(a.name, 'ru'))
  }, [list, sortAsc])

  // useEffect(() => {
  //   selectedItem &&
  //   handleCheck(selectedItem)
  // }, [selectedItem])


  const openModal = (data) => () => {
    setAddMode(true)
    setSelectedItem(data || {})
  }

  const closeModal = () => {
    setSelectedItem(null)
    setAddMode(false)
  }
  const goHome = () => navigate('/')

  const acceptConfirmation = () => {
    closeModal();
    dispatch(deleteTvProgramType(confirmation.id));
    setConfirmation(false);
  };
  const rejectConfirmation = () => {
    setConfirmation(false);
  };
  const renderLi = (data) => {
    const { id, name, color } = data
    return (
      <tr  >
        <td name='weight' onClick={openModal(data)}>{name}</td>
        <td name='color' onClick={openModal(data)} style={{ backgroundColor: `#${color}` }}></td>
        <td><i className={styles.trash} onClick={() => setConfirmation({ id, name })}><BiTrash /></i></td>
      </tr>
    )
  }

  return (
    <div className={styles.wrapper} style={{ width: '700px', margin: '0 auto' }}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Удалить тип ${confirmation.id}?`}
          // confirmation={confirmation?.name} 
          acceptConfirmation={() => acceptConfirmation(confirmation?.name)}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      {selectedItem &&
        <Modal
          open={!!selectedItem}
          closeModal={closeModal}
          data={selectedItem}
          addMode={!selectedItem?.id}
          height={'500px'}
        />
      }
      <h1>Типы программ</h1>
      <div style={{ marginTop: '2rem', backgroundColor: 'white' }}>
        <Table >
          <thead>
            <tr>
              <th onClick={() => setSortAsc(v => !v)} style={{ cursor: 'pointer' }}>Название</th>
              <th>Цвет</th>
              <th style={{ width: '70px' }}>Удалить</th>
            </tr>
          </thead>
          <tbody>

            {sortedList.map(renderLi)}

          </tbody>
        </Table>
      </div>


      <div style={{ display: 'flex', flexDirection: "row" }}>
        <Button
          style={{ padding: '.5rem 1.5rem', margin: '12px' }}
          onClick={openModal()}
        >
          <IoIosAdd size={30} />
          Добавить
        </Button>

      </div>
    </div>
  )
}
